export enum AssessmentManagedTypeContextEnum {
  MySchool = 1,
  Special = 2,
}
